/**
 * Basic MF Slot Web Component
 * Dispatches events when added/removed from DOM
 */

import { logger } from '@mf-tools/cli-common';

const log = logger.browser('mf-slot');

export class MFSlotElement extends HTMLElement {
  async connectedCallback() {
    log.info('[MFSlot] connectedCallback fired for', this.id || 'unnamed slot');

    // Wait for attributes to be set by Angular
    // Angular sets attributes asynchronously after DOM insertion
    await new Promise(resolve => setTimeout(resolve, 0));

    // Create shadow DOM
    // const shadow = this.attachShadow({ mode: 'open' });

    // // Add basic styling
    // shadow.innerHTML = `
    //   <style>
    //     :host {
    //       display: block;
    //       padding: 16px;
    //       border: 2px dashed #008193;
    //       border-radius: 8px;
    //       background: #f0f9fa;
    //     }
    //     .slot-header {
    //       font-family: 'Mulish', sans-serif;
    //       color: #04293e;
    //       font-weight: bold;
    //       margin-bottom: 8px;
    //     }
    //     .slot-content {
    //       color: #6d778a;
    //     }
    //   </style>
    //   <div class="slot-header">MF Slot: ${this.id || 'unnamed'}</div>
    //   <div class="slot-content">
    //     <slot></slot>
    //   </div>
    // `;

    // Read attributes and pass them in event detail
    log.info('constructor mf-slot:connected', this.id, this.getAttribute('domain'), this.getAttribute('name'), this.getAttribute('props'));
    this.dispatchEvent(new CustomEvent('mf-slot:connected', {
      detail: {
        element: this,
        id: this.id,
        // Add any attributes you want to pass
        domain: this.getAttribute('domain'),
        name: this.getAttribute('name'),
        props: this.getAttribute('props') ? JSON.parse(this.getAttribute('props')) : {}
      },
      bubbles: true,
      composed: true
    }));

    this.dispatchEvent(new CustomEvent('mf-slot:mount', {
      detail: {
        element: this,
        // shadowRoot: shadow,
        id: this.id,
        domain: this.getAttribute('domain'),
        name: this.getAttribute('name'),
        props: this.getAttribute('props') ? JSON.parse(this.getAttribute('props')) : {}
      },
      bubbles: true,
      composed: true
    }));
  }

  disconnectedCallback() {
    log.info('[MFSlot] disconnectedCallback fired for', this.id || 'unnamed slot');

    // Dispatch disconnected event
    this.dispatchEvent(new CustomEvent('mf-slot:disconnected', {
      detail: {
        element: this,
        id: this.id
      },
      bubbles: true,
      composed: true
    }));
  }
}